module.exports = __webpack_public_path__ + "static/private-896f0acb2e51a1a8e2fc2d35c6ce5920.pdf";